export const isApc = Boolean(window.isApc);
export const makeId = (length = 5) => {
  let text = '';
  const possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};
export const getComparisonSessionId = () => {
  const seSessionId = 'COMPARISON_SESSION_ID';
  const apcSessionId = 'APC_COMPARISON_SESSION_ID';
  const COMPARISON_SESSION_ID = !isApc ? seSessionId : apcSessionId;
  let sessionId = localStorage.getItem(COMPARISON_SESSION_ID);
  if (!sessionId) {
    sessionId = makeId();
    localStorage.setItem(COMPARISON_SESSION_ID, sessionId);
  }
  return sessionId;
};
export const getComparatorThreshold = () => {
  const comparatorThreshold = parseInt(window.comparatorThreshold);
  return isNaN(comparatorThreshold) ? undefined : comparatorThreshold;
};
export const COMPARATOR_LOCALE = document.documentElement.lang.replace('-', '_');
export const getStorageComparatorName = () => {
  if (!isApc) {
    return `pesProductComparisonList_${COMPARATOR_LOCALE}`;
  }
  return 'comparisonList';
};
